
export type SkinTier = 'public' | 'premium';

export interface WeaponSkinOption {
  name: string;
  weaponKey: string;
  title: string;
  tier: SkinTier;
  rarity: string | null;
  owned: boolean;
}

export const stockSrc = (weaponKey: string): string => `/battle/weapon_${weaponKey}.webp`;

const RARITY_COLOR: Record<string, string> = {
  covert: '#eb4b4b',
  classified: '#d32ce6',
  restricted: '#8847ff',
  milspec: '#4b69ff',
};

export const rarityColor = (rarity: string | null): string => (rarity && RARITY_COLOR[rarity]) || '#4b69ff';

export const STOCK: WeaponSkinOption = {
  name: '',
  weaponKey: '',
  title: 'Сток',
  tier: 'public',
  rarity: null,
  owned: true,
};
